import React, { useState, useEffect } from 'react'
import MainSelector from '../MainSelector'
import './mailing.scss'
import icon from '../../../../img/layout.svg'
import send from '../../../../img/send.svg'
import InputPhone from 'components/ContentBox/Global/InputPhone/InputPhone'
import SelectRequest from '../../../Select/SelectRequest'
import Select from '../../../Select/Select'
import TypeSelector from '../WorkPlain/TypeSelector'
import SelectDateBirth from '../../../SelectDateBirth/SelectDateBirth'
import 'react-datepicker/dist/react-datepicker.css'
import DatePicker from 'react-datepicker'
import Stores from 'Stores'
import { timeConverter } from '../../../../Online-schedule/components/functions'
import { superAxiosRequest } from 'axiosApi'
import { localisationMaster } from 'Localisation/Localisation'

export default function Mailing(props) {
  const [values, setvalues] = useState({ type: 0 })
  const [studentList, setStudentList] = useState([])
  const [studentType, setstudentType] = useState(0)
  const [testEmail, setTestEmail] = useState('')
  const [testSMS, setSMS] = useState('')

  const objectChangeHandler = (value, state) => {
    setvalues({ ...values, [state]: value })
  }

  const cleanTime = (date) => {
    let h = date.getHours()
    if (+h < 10) h = '0' + h
    let m = date.getMinutes()
    if (+m < 10) m = '0' + m
    return `${h}:${m}`
  }

  const types = [
    { id: 0, name: 'E-mail' },
    { id: 1, name: 'SMS' },
    { id: 2, name: 'Telegram' },
  ]

  const studentsTypes = [
    { id: 1, name: localisationMaster('text_22', 'groups/group', 'modal') },
    { id: 2, name: localisationMaster('text_21', 'groups/group', 'modal') },
    { id: 3, name: localisationMaster('text_20', 'groups/group', 'modal') },
    { id: 4, name: localisationMaster('text_19', 'groups/group', 'modal') },
    { id: 5, name: localisationMaster('deleted', 'groups/group') },
  ]

  const sendNowHandler = () => {
    let date = timeConverter(new Date(), 'today')
    let time = timeConverter(new Date(), 'time')
    setvalues({ ...values, start_at: time, date_from: date })
  }

  useEffect(() => {
    if (studentType > 0) {
      let st = Stores.observableArray(props.modal_settings.students)
      st = st.filter((x) => +x.status === +studentType)
      setStudentList(st)
    }
  }, [studentType])

  useEffect(() => {
    setvalues({ ...values, clients: studentList.map((item) => item.id) })
  }, [studentList])

  const testMsg = (type) => {
    let conf = {
      link: 'mailings/test',
      method: 'post',
    }
    let body = { ...values }
    body.type = types.find((x) => x.id === body.type).name
    delete body.clients

    switch (type) {
      case 'email':
        body.is_test = true
        body.is_test_sms = false
        body.test_email = testEmail.replaceAll(' ', '').split(',')
        body.test_phone = '0'
        break
      case 'sms':
        body.is_test = false
        body.is_test_sms = true
        body.test_phone = testSMS
        body.test_email = '0'
        break
      default:
        break
    }

    superAxiosRequest(conf, body).then()
  }

  useEffect(() => {
    let arr = { ...values }
    arr.type = types.find((x) => x.id === arr.type).name
    props.arrayChangeHandler(arr)
  }, [values])

  useEffect(() => {
    let type = types.find((x) => x.name === props.fix_data.type)
    let arr = { ...props.fix_data, type: type?.id || 0 }
    setvalues({ ...arr })
  }, [])

  return (
    <div className='mailingBox'>
      <div className='mailingBox_name'>
        <span>{localisationMaster('text_8', 'groups/group', 'modal')}</span>
        <input
          type='text'
          onChange={(e) => objectChangeHandler(e.target.value, 'name')}
          value={values.name}
          placeholder={localisationMaster('text_8', 'groups/group', 'modal')}
        />
      </div>
      <MainSelector image={icon}>
        <div className='mailingBox__main-select'>
          <SelectRequest
            valueId={+values.template || 0}
            selected={0}
            myChangeHandler={(e) =>
              objectChangeHandler(e.target.value, 'template')
            }
            text={localisationMaster('text_17', 'groups/group', 'modal')}
            width='100%'
            new_key='title'
            link='mailings/templates'
          />
          <TypeSelector
            values={types}
            like_obj={true}
            objectChangeHandler={objectChangeHandler}
            selected={+values.type || 0}
            name={'type'}
          />
          <div className='mailingBox__main-select__dateField'>
            <div className='mailingBox__main-select__dateField--dateNote'>
              <span>
                {localisationMaster('text_9', 'groups/group', 'modal')}
              </span>
              <SelectDateBirth
                value={values.lesson_date_from || null}
                onChange={(value) =>
                  objectChangeHandler(value, 'lesson_date_from')
                }
              />
            </div>
            <div className='mailingBox__main-select__dateField--dateNote'>
              <span>
                {localisationMaster('text_10', 'groups/group', 'modal')}
              </span>
              <DatePicker
                selected={
                  new Date('2020-01-01 ' + (values.lesson_start_at || '12:00'))
                }
                onChange={(date) =>
                  objectChangeHandler(cleanTime(date), 'lesson_start_at')
                }
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={5}
                timeCaption={localisationMaster(
                  'text_10',
                  'groups/group',
                  'modal',
                )}
                timeFormat='HH:mm'
                dateFormat='HH:mm'
              />
            </div>
          </div>
        </div>
      </MainSelector>

      <div className='mailingBox__main-select__dateField--dateNote'>
        <span>{localisationMaster('text_16', 'groups/group', 'modal')}</span>
        <Select
          s_value={studentType}
          selected={0}
          myChangeHandler={(e) => setstudentType(e.target.value)}
          text={localisationMaster('text_23', 'groups/group', 'modal')}
          value={studentsTypes}
          width='100%'
        />
      </div>

      <div
        className='mailingBox__main-select__dateField--dateNote'
        style={{ marginTop: '20px' }}
      >
        <span>{localisationMaster('text_16', 'groups/group', 'modal')}</span>
        {studentList.length > 0 ? (
          <div className='cpt__students--list'>
            <ul>
              {studentList.map((item, index) => (
                <li key={index}>
                  {index + 1}. {item.full_name}{' '}
                  <span
                    onClick={() =>
                      setStudentList(
                        studentList.filter((x) => x.id !== item.id),
                      )
                    }
                  >
                    х
                  </span>
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <div className='sg-probka'>
            {localisationMaster('text_15', 'groups/group', 'modal')}
          </div>
        )}
      </div>

      <div className='mailingBox__main-select__dateField'>
        <div className='mailingBox__main-select__dateField--dateNote'>
          <span>{localisationMaster('text_14', 'groups/group', 'modal')}</span>
          <SelectDateBirth
            value={values.date_from || null}
            onChange={(value) => objectChangeHandler(value, 'date_from')}
          />
        </div>
        <div className='mailingBox__main-select__dateField--dateNote'>
          <span>{localisationMaster('text_10', 'groups/group', 'modal')}</span>
          <DatePicker
            selected={new Date('2020-01-01 ' + (values.start_at || '12:00'))}
            onChange={(date) =>
              objectChangeHandler(cleanTime(date), 'start_at')
            }
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={5}
            timeCaption={localisationMaster('text_10', 'groups/group', 'modal')}
            timeFormat='HH:mm'
            dateFormat='HH:mm'
          />
        </div>
        <span
          style={{
            fontWeight: '600',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            height: '45px',
            cursor: 'pointer',
            justifyContent: 'center',
          }}
          onClick={sendNowHandler}
        >
          {localisationMaster('text_11', 'groups/group', 'modal')}
        </span>
      </div>

      <div className='mailingBox__dateField'>
        <MainSelector image={icon} style={{ marginTop: '20px' }}>
          <div className='mailingBox__main-select'>
            <div className='mailingBox__main-select__dateField--dateNote'>
              <span>
                {localisationMaster('text_12', 'groups/group', 'modal')}
              </span>
              <div className='mailingBox__main-select__dateField--dateNote--line'>
                <input
                  type='text'
                  onChange={(e) => setTestEmail(e.target.value)}
                />
                <div
                  className='mailingBox__main-select__dateField--dateNote--line--btn'
                  onClick={() => testMsg('email')}
                >
                  <img src={send} alt='icon' />
                </div>
              </div>

              <span>
                {localisationMaster('text_13', 'groups/group', 'modal')}
              </span>
              <div className='mailingBox__main-select__dateField--dateNote--line'>
                <div style={{ width: '80%' }}>
                  <InputPhone
                    value={values.test_phone}
                    onChange={(val) => {
                      setSMS(val)
                    }}
                  />
                </div>
                <div
                  className='mailingBox__main-select__dateField--dateNote--line--btn'
                  onClick={() => testMsg('sms')}
                >
                  <img src={send} alt='icon' />
                </div>
              </div>
            </div>
          </div>
        </MainSelector>
      </div>
    </div>
  )
}
